import { Component, Input } from '@angular/core';
import { SubCategoryPerformance } from '../../../models/analytics.model';

@Component({
    selector: 'app-analytics-performance-table',
    templateUrl: './analytics-performance-table.component.html',
    styleUrls: ['./analytics-performance-table.component.scss'],
})
export class AnalyticsPerformanceTableComponent {
    @Input() data: SubCategoryPerformance[] = [];
    @Input() comparePrevious = false;

    getDelta(item: SubCategoryPerformance): number | null {
        if (!this.comparePrevious || item.previousComplianceRate === undefined || item.previousComplianceRate === null) {
            return null;
        }
        return item.complianceRate - item.previousComplianceRate;
    }

    isNewInPeriod(item: SubCategoryPerformance): boolean {
        return this.comparePrevious && item.previousComplianceRate === null;
    }

    getStatusLabel(status: string): string {
        switch (status) {
            case 'critical':
                return 'request_v2.analytics.perf_critical';
            case 'warning':
                return 'request_v2.analytics.perf_warning';
            case 'compliant':
                return 'request_v2.analytics.perf_compliant';
            default:
                return status;
        }
    }

    getBarColor(status: string): string {
        switch (status) {
            case 'critical':
                return '#ef4444';
            case 'warning':
                return '#f59e0b';
            case 'compliant':
                return '#10b981';
            default:
                return '#9ca3af';
        }
    }
}
